/**
 * Breekpunten van stijl A (ronde 3, 28-10-2026): de enige bron.
 *
 * Drie maten, genoemd naar wat Tom gebruikt:
 * - `wide`   vanaf 1536 px: een groot scherm, 1600 x 1000 zoals de mockups;
 * - `medium` 1360 tot en met 1535 px: de MacBook Pro 14 inch (ca. 1512 x 860);
 * - `narrow` onder 1360 px: dezelfde laptop met een zijpaneel of gesplitst
 *   scherm (ca. 1280 x 800).
 *
 * De schil zet de maat als `data-viewport` op `<html>` (`useViewportAttribute`).
 * CSS schrijft daarom `:root[data-viewport="narrow"] .x { … }` en geen losse
 * `@media`-getallen. Dezelfde waarden staan als documentatietokens in
 * tokens.css (`--atlas-bp-*`); verander ze altijd hier en daar samen.
 */
export const BREAKPOINTS = {
  /** Vanaf deze breedte is het `wide`. */
  wide: 1536,
  /** Vanaf deze breedte is het `medium`, daaronder `narrow`. */
  medium: 1360,
} as const;

export type Viewport = "wide" | "medium" | "narrow";

/** De maat bij een vensterbreedte in CSS-pixels. */
export function viewportFor(width: number): Viewport {
  if (width >= BREAKPOINTS.wide) return "wide";
  if (width >= BREAKPOINTS.medium) return "medium";
  return "narrow";
}

/**
 * Onder deze breedte is de dichtheid standaard Compact (zie `density.ts`).
 * Bewust een eigen grens en niet `medium`: op 1440 past Ruim nog, op de
 * MacBook (1512 met Dock en zijpaneel vaak minder) kiest de gebruiker zelf.
 */
export const COMPACT_BELOW = 1440;
